import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { useQuery } from '@tanstack/react-query';
import { getCategories } from '@dealstack/frontend/app/services/Blog.service.ts';
import { ApplicationType } from '@dealstack/shared/lib/generated';
import type { ClientPerspective } from '@sanity/client';

export const useCategories = (
	dataset: ApplicationType,
	language: string,
	perspective?: ClientPerspective
) => {
	const request = useQuery({
		queryKey: [API_PATHS.HELP_BLOG_DATASET_CATEGORIES_GET, { dataset, language, perspective }],
		queryFn: () =>
			getCategories(API_PATHS.HELP_BLOG_DATASET_CATEGORIES_GET, {
				dataset,
				language,
				perspective,
			}),
	});

	return {
		categories: request.data || [],
		isFetching: request.isFetching,
	};
};
